module.exports = __webpack_public_path__ + "static/media/14.Cordless Drill.4c712250.jpeg";